module.exports = __webpack_public_path__ + "img/cl_admin_avatar.ebdf82fc.png";